import { createReactComponent } from '@tabler/icons-react';

export const IconCustomTagQuestion = createReactComponent(
  'outline',
  'customTagQuestion',
  'CustomTagQuestion',
  [
    [
      'path',
      {
        key: 'customTagQuestion-path-1',
        d: 'M14.1693 20.6991C13.8147 20.8958 13.4128 21.0017 13 21.0017C12.3609 21.0017 11.748 20.7479 11.296 20.296L3.586 12.586C3.2109 12.211 3.00011 11.7024 3 11.172V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H11.172C11.7024 3.00011 12.211 3.2109 12.586 3.586L19.8187 10.8187M19 22V22.01M19 19.0001C19.4483 18.9986 19.8831 18.8468 20.2349 18.569C20.5868 18.2912 20.8352 17.9033 20.9405 17.4676C21.0458 17.0318 21.0019 16.5733 20.8158 16.1655C20.6297 15.7577 20.3121 15.4241 19.914 15.2181C19.5162 15.0143 19.0611 14.9511 18.6228 15.0388C18.1845 15.1265 17.7888 15.3599 17.5 15.7011M6.5 7.5C6.5 7.76522 6.60536 8.01957 6.79289 8.20711C6.98043 8.39464 7.23478 8.5 7.5 8.5C7.76522 8.5 8.01957 8.39464 8.20711 8.20711C8.39464 8.01957 8.5 7.76522 8.5 7.5C8.5 7.23478 8.39464 6.98043 8.20711 6.79289C8.01957 6.60536 7.76522 6.5 7.5 6.5C7.23478 6.5 6.98043 6.60536 6.79289 6.79289C6.60536 6.98043 6.5 7.23478 6.5 7.5Z',
      },
    ],
  ]
);
